import { createSelector, createStructuredSelector } from "reselect";
import { selectUserInfo, selectUserName, selectHasUserAcceptedTnC, selectTnCForCidpUser } from "scenes/selectors";
import { initialState, State as EditPasswordState } from "./redux";

/**
 * Direct selector to the EditPassword state domain
 */

const selectEditPasswordDomain: (any) => EditPasswordState = (state) =>
  state.dashboardEditPassword || initialState;

/**
 * Custom selectors to the EditPassword state
 */
export const selectEditPassword = createSelector(
  selectEditPasswordDomain,
  (substate) => substate
);

export const selectLoadingPasswordPolicies = createSelector(
  selectEditPasswordDomain,
  (substate) => substate.loadingPasswordPolicies
);

export const getPasswordPolicies = createSelector(
  selectEditPasswordDomain,
  (substate) => substate.passwordPolicies
);

export const selectSubmitting = createSelector(
  selectEditPasswordDomain,
  (substate) => substate.submitting
);

export const selectPasswordUpdated = createSelector(
  selectEditPasswordDomain,
  (substate) => substate.passwordUpdated
);

export const selectIncorrectOldPasswordError = createSelector(
  selectEditPasswordDomain,
  (substate) => substate.apiPasswordError === "CURRENT_PASSWORD_INCORRECT"
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectEditPassword = () =>
  createSelector(selectEditPasswordDomain, (substate) => substate);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  loadingPasswordPolicies: selectLoadingPasswordPolicies,
  passwordPolicies: getPasswordPolicies,
  submitting: selectSubmitting,
  passwordUpdated: selectPasswordUpdated,
  userName: selectUserName,
  userInfo: selectUserInfo,
  isOldPasswordIncorrect: selectIncorrectOldPasswordError,
  updatedTnC: selectTnCForCidpUser,
  hasUpdatedTnCAccepted: selectHasUserAcceptedTnC,
  tncForCidpUser: selectTnCForCidpUser,
});
